<template>
  <b-taginput
    :data="filteredYears"
    :placeholder="$t('compSuperadminSettingsWarningYears.label')"
    :allow-new="false"
    ref="yearstaginput"
    v-model="buffer"
    :open-on-focus="true"
    @input="$emit('input', buffer)"
    rounded
    icon="caret-right"
    @typing="getFilteredYears"
    autocomplete
  >
    <template v-slot="props">
      {{ $t(props.option) }}
    </template>
    <template #selected="props">
      <b-tag
        v-for="(tag, index) in props.tags"
        :key="index"
        rounded
        :tabstop="false"
        ellipsis
        closable
        @close="$refs.yearstaginput.removeTag(index, $event)"
      >
        {{ tag }}
      </b-tag>
    </template>
  </b-taginput>
</template>

<script>
import _ from 'lodash'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'WarningYears',
  inject: ['$validator'],
  props: {
    value: Array
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data () {
    return {
      buffer: this.value,
      filteredYears: []
    }
  },
  computed: {
    allYears: function () {
      let now = new Date()
      return _.range(now.getFullYear() - 10, now.getFullYear())
    }
  },
  methods: {
    getFilteredYears (text) {
      this.filteredYears = this.allYears.filter((year) => {
        return year.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = this.value
      },
      deep: true
    }
  },
  mounted () {
    this.buffer = this.coreStore.setting('global', 'WARNING_YEARS').value
    this.filteredYears = this.allYears
  }
}
</script>
